import React from "react";
import { forwardRef } from "react";

const InputSearch = (
  {
    name,
    value,
    handleChange,
    setSearch,
    width,
    onClick,
    paddingRight,
    paddingLeft,
    searchInputRef = null,
  },
  ref
) => {
  const handleClick = () => {
    setSearch("");
    if (onClick !== undefined) {
      onClick("hide");
    }
  };

  return (
    <div className="search_field">
      <input
        ref={searchInputRef}
        className="input_field"
        style={{ width: width }}
        type="text"
        name={name}
        value={value}
        onChange={(e) => {
          if (e.target.value.length < 101) {
            handleChange(e);
          }
        }}
        autoComplete="on"
        aria-label="Search by family or client name"
      />
      <svg
        className="search"
        style={{ left: paddingLeft }}
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M15.732 14.7022L12.6952 11.6564C12.6651 11.6326 12.6331 11.6113 12.5995 11.5926C13.7439 10.1771 14.303 8.3751 14.1614 6.55827C14.0198 4.74144 13.1883 3.04844 11.8384 1.82857C10.4886 0.608692 8.72341 -0.0449822 6.90707 0.0024078C5.09074 0.0497978 3.36183 0.794637 2.07705 2.08325C0.792272 3.37186 0.0496496 5.10593 0.00240064 6.92769C-0.0448483 8.74945 0.606881 10.5199 1.82312 11.8738C3.03937 13.2276 4.72733 14.0616 6.53875 14.2037C8.35017 14.3457 10.1469 13.785 11.5581 12.6371C11.5767 12.6708 11.598 12.7029 11.6217 12.7331L14.6585 15.779C14.801 15.9209 14.9938 16.0004 15.1947 16C15.3955 15.9996 15.588 15.9194 15.73 15.777C15.8721 15.6345 15.952 15.4415 15.9524 15.24C15.9527 15.0386 15.8735 14.8452 15.732 14.7022V14.7022ZM7.09716 13.21C5.89593 13.21 4.72167 12.8528 3.72288 12.1834C2.72409 11.514 1.94563 10.5626 1.48594 9.44953C1.02624 8.33642 0.905968 7.11159 1.14032 5.92992C1.37467 4.74825 1.95312 3.66282 2.80252 2.81088C3.65192 1.95895 4.73412 1.37877 5.91227 1.14372C7.09043 0.908673 8.31161 1.02931 9.42141 1.49037C10.5312 1.95144 11.4798 2.73222 12.1471 3.73399C12.8145 4.73576 13.1707 5.91353 13.1707 7.11835C13.1689 8.7334 12.5284 10.2818 11.3898 11.4238C10.2512 12.5658 8.70741 13.2082 7.09716 13.21Z"
          fill="#03002F"
        />
      </svg>
      {value.length !== 0 && (
        <svg
          className="close"
          style={{ right: paddingRight }}
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
          onClick={handleClick}
        >
          <path d="M5.6582 5.34229L16.9719 16.656" stroke="black" />
          <path d="M5.6582 16.6577L16.9719 5.34401" stroke="black" />
        </svg>
      )}
    </div>
  );
};

export default forwardRef(InputSearch);
